module.exports = __webpack_public_path__ + "static/img/1-2.98334a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/1-2.png
// module id = QgWH
// module chunks = 0